export default {
  okText: 'Ok',
  dismissText: 'Annuller',
  extra: 'VÃ¦lg venligst'
};
